import PolicyDetail from './policies-entity-detail';
import RequireAuth from '@converge/ui/domain/auth/require-auth';

export const PolicyDetailPage = () => {
  return (
    <RequireAuth>
      <PolicyDetail />
    </RequireAuth>
  );
};

export default PolicyDetailPage;
